// Alpine.js
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse';
global.Alpine = Alpine
Alpine.plugin(collapse);
Alpine.start();


// GSAP
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

const specialtiesButton = document.querySelector("#specialties-button");
if (specialtiesButton) {
    specialtiesButton.addEventListener("click", () => {
        gsap.to(window, {duration: 0.5, scrollTo:{y:"#specialties", offsetY:85}});
    });
}


// Lazy load images
import Lazyload from 'vanilla-lazyload';
global.Lazyload = Lazyload;

// Create Lazy load instance
var lazyLoadInstance = new Lazyload({
    elements_selector: '.lazy'
    // ... more custom settings?
});
global.lazyLoadInstance = lazyLoadInstance;



const Flickity = require('flickity');
require('flickity-imagesloaded');
require('flickity-fade');
global.Flickity = Flickity;



import { Fancybox } from "@fancyapps/ui";
